export class NotificationData {

  time: string | undefined;
  notificationType: NotificationType;

  constructor(
    notificationType: NotificationType,
    time?: string,
  ) {
    this.notificationType = notificationType;
    this.time = time;
  }
}

export interface NotificationOptions {
  body?: string;
  icon?: string;
  image?: string;
  badge?: string;
}

export enum NotificationType {
  ScoreReminder,
  ScienceBite,
  PlanReminder,
  Community
}

/**
 * A single Community (NodeBB) notification card (FLIP-161). Unlike ScoreReminder/
 * ScienceBite, these carry their own dynamic title/body/deepLink from the webhook
 * payload rather than static per-type copy, and more than one can be active at once -
 * see DialogNotificationService.communityNotifications.
 */
export class CommunityNotificationData {
  constructor(
    public title: string,
    public body: string,
    public deepLink?: string,
  ) {}
}
